import { render, staticRenderFns } from "./ContractRow.vue?vue&type=template&id=2fdfe183&scoped=true"
import script from "./ContractRow.vue?vue&type=script&lang=js"
export * from "./ContractRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdfe183",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fdfe183')) {
      api.createRecord('2fdfe183', component.options)
    } else {
      api.reload('2fdfe183', component.options)
    }
    module.hot.accept("./ContractRow.vue?vue&type=template&id=2fdfe183&scoped=true", function () {
      api.rerender('2fdfe183', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/purchaseService/components/ContractRow.vue"
export default component.exports